import { combineEpics } from "redux-observable";
import * as _ from "lodash";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import myActivitiesActionTypes from "./MyActivitiesActionTypes.js";
import MyActivitiesActions from "./MyActivitiesActions.js";
var ExperimentPivots = /* @__PURE__ */ ((ExperimentPivots2) => {
  ExperimentPivots2["new"] = "new";
  ExperimentPivots2["running"] = "running";
  ExperimentPivots2["completed"] = "completed";
  return ExperimentPivots2;
})(ExperimentPivots || {});
const myActivitiesUserContextParams = {
  // TODO: this should really be a paramType => "enum", and isMultiValue = false, but that is not implemented yet
  pivot: { paramType: "string", defaultValue: "running" }
};
const produceMyActivitiesRouteQueryStringSyncEpics = (history) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    myActivitiesUserContextParams,
    MyActivitiesActions.setUserContext,
    myActivitiesActionTypes.SET_PARTIAL_USER_CONTEXT,
    myActivitiesActionTypes.SET_USER_CONTEXT,
    // todo: we need to pass in a func that allows us to "find" the user context in the store
    // to be more of a plugin, this method should not "know" this, but rather be passed in
    // this would allow this to be used in the context of an app-module, and its hosting app
    (store) => store.experimentSearchModule.myActivities.userContext,
    history,
    (pathname) => _.includes(["/", "/a/search/myactivities"], pathname),
    EXP_QUERY_STRINGS
  );
  return combineEpics(...Object.values(setUserContextFromRouteQueryString));
};
export {
  ExperimentPivots,
  myActivitiesUserContextParams,
  produceMyActivitiesRouteQueryStringSyncEpics
};
//# sourceMappingURL=MyActivitiesUserContext.js.map
